
// #region actions
export type QuoteListActionTypes =    
    SetCurrentPageAction
    | UpdateQueryAction
    | SetPageSizeAction
    | SetStatusFilterAction 
    | SetSearchTextAction   
    | SetTotalCountAction

export const SET_CURRENT_PAGE = "SET_QUOTE_CURRENT_PAGE";
export interface SetCurrentPageAction {
    type: typeof SET_CURRENT_PAGE;
    currentPage: number;
}
export const SET_PAGE_SIZE = "SET_QUOTE_PAGE_SIZE";
export interface SetPageSizeAction {
    type: typeof SET_PAGE_SIZE;
    pageSize: number;
}
export const UPDATE_QUERY = "UPDATE_QUOTE_QUERY";
export interface UpdateQueryAction {
    type: typeof UPDATE_QUERY;
    lastQuery: string;
}

export const SET_STATUS_FILTER = "SET_QUOTE_STATUS_FILTER";
export interface SetStatusFilterAction {
    type: typeof SET_STATUS_FILTER;
    statusFilter: number;
}

export const SET_SEARCH_TEXT = "SET_QUOTE_SEARCH_TEXT";
export interface SetSearchTextAction {
    type: typeof SET_SEARCH_TEXT;
    searchText: string;
}

export const SET_TOTAL_COUNT = "SET_QUOTE_TOTAL_COUNT";
export interface SetTotalCountAction {
    type: typeof SET_TOTAL_COUNT;
    totalCount: number;
}